// extracted by mini-css-extract-plugin
export default {"email_sended_container":"EmailSended_email_sended_container__tZbfA","details_container":"EmailSended_details_container__HLtlL","image_container":"EmailSended_image_container__7vRTI"};